export function parsePositiveQuantity(value: string): number | null {
  const trimmedValue = value.trim();
  const quantity = Number(trimmedValue);
  return /^\d+$/.test(trimmedValue) &&
    Number.isSafeInteger(quantity) &&
    quantity > 0
    ? quantity
    : null;
}

export function parsePositiveDimension(value: string): number | null {
  const trimmedValue = value.trim();
  const dimension = Number(trimmedValue);
  return /^(?:\d+(?:\.\d*)?|\.\d+)$/.test(trimmedValue) &&
    Number.isFinite(dimension) &&
    dimension > 0 &&
    dimension <= Number.MAX_SAFE_INTEGER
    ? dimension
    : null;
}
